import { useMutation } from "@tanstack/react-query"
import { insertNdaInfo } from "@/api"

export const useInsertNda = () => {
  return useMutation({
    mutationFn: ({
      legalName,
      email,
      address,
      city,
      state,
      zip,
      phone,
    }: {
      legalName: string
      email: string
      address: string
      city: string
      state: string
      zip: string
      phone: string
    }) =>
      insertNdaInfo({
        legalName,
        email,
        address,
        city,
        state,
        zip,
        phone,
      }),
  })
}
